import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores'
import { useAdminStore } from '@/stores/admin'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // Public routes
    {
    path: '/',
    name: 'Home',
    component: () => import('@/views/public/NewHome.vue'),
  },
  {
    path: '/models',
    name: 'Models',
    component: () => import('@/views/public/Home.vue'),
    meta: { pageTitle: 'Models' },
  },
  {
    path: '/kernels',
    name: 'Kernels',
    component: () => import('@/views/public/Kernels.vue'),
    meta: { pageTitle: 'Kernels' },
  },
  {
    path: '/kernels/:id',
    name: 'KernelDetailPublic',
    component: () => import('@/views/public/KernelDetail.vue'),
    meta: { pageTitle: 'Kernel' },
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/public/News.vue'),
    meta: { pageTitle: 'News' },
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/public/NewsDetail.vue'),
    meta: { pageTitle: 'News' },
  },
  {
    path: '/apps',
    name: 'Apps',
    component: () => import('@/views/public/Apps.vue'),
    meta: { pageTitle: 'Apps' },
  },
  {
    path: '/flashagent',
    redirect: '/apps',
  },
  {
    path: '/flashcli',
    name: 'FlashCLI',
    component: () => import('@/views/public/FlashCLI.vue'),
    meta: { pageTitle: 'FlashCLI' },
  },
  {
    path: '/agent',
    name: 'Agent',
    component: () => import('@/views/public/Agent.vue'),
    meta: { pageTitle: 'AI Agent' },
  },
  {
    path: '/kernel-docs',
    name: 'KernelDocs',
    component: () => import('@/views/public/KernelDocs.vue'),
    meta: { pageTitle: 'Kernel Docs' },
  },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/auth/Login.vue'),
      meta: { pageTitle: 'Login' },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
      meta: { pageTitle: 'Sign Up' },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/views/auth/ForgotPassword.vue'),
      meta: { pageTitle: 'Forgot Password' },
    },
    {
      path: '/github/callback',
      name: 'GitHubCallback',
      component: () => import('@/views/auth/GitHubCallback.vue'),
      meta: { pageTitle: 'GitHub Login' },
    },
    {
      path: '/repositories/:id',
      name: 'RepositoryDetail',
      component: () => import('@/views/public/RepositoryDetail.vue'),
      meta: { pageTitle: 'Repository' },
    },
    
    // Protected routes
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/layouts/DashboardLayout.vue'),
      meta: { requiresAuth: true, pageTitle: 'My Repositories' },
      children: [
        {
          path: '',
          name: 'DashboardHome',
          component: () => import('@/views/dashboard/Home.vue'),
          meta: { pageTitle: 'Dashboard' },
        },
        {
          path: 'repositories',
          redirect: '/dashboard',
        },
        {
          path: 'repositories/:id',
          name: 'RepositoryManage',
          component: () => import('@/views/repository/Manage.vue'),
          meta: { pageTitle: 'Manage Repository' },
        },
        {
          path: 'repositories/:id/versions',
          name: 'VersionManage',
          component: () => import('@/views/repository/Versions.vue'),
          meta: { pageTitle: 'Manage Versions' },
        },
        {
          path: 'repositories/:id/versions/create',
          name: 'CreateVersion',
          component: () => import('@/views/repository/CreateVersion.vue'),
          meta: { pageTitle: 'Create Version' },
        },
        {
          path: 'create',
          name: 'CreateRepository',
          component: () => import('@/views/repository/Create.vue'),
          meta: { pageTitle: 'Create Repository' },
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('@/views/dashboard/Profile.vue'),
          meta: { pageTitle: 'Profile' },
        },
        // Organization routes
        {
          path: 'organizations',
          name: 'MyOrganizations',
          component: () => import('@/views/organization/List.vue'),
          meta: { pageTitle: 'My Organizations' },
        },
        {
          path: 'organizations/create',
          name: 'CreateOrganization',
          component: () => import('@/views/organization/Create.vue'),
          meta: { pageTitle: 'Create Organization' },
        },
        {
          path: 'organizations/:id/edit',
          name: 'EditOrganization',
          component: () => import('@/views/organization/Create.vue'),
          meta: { pageTitle: 'Edit Organization' },
        },
        {
          path: 'organizations/:id/members',
          name: 'OrgMembers',
          component: () => import('@/views/organization/OrgMembers.vue'),
          meta: { pageTitle: 'Organization Members' },
        },
        // Kernel routes
        {
          path: 'kernels',
          name: 'MyKernels',
          component: () => import('@/views/kernel/List.vue'),
          meta: { pageTitle: 'My Kernels' },
        },
        {
          path: 'kernels/upload',
          name: 'UploadKernel',
          component: () => import('@/views/kernel/Upload.vue'),
          meta: { pageTitle: 'Upload Kernel' },
        },
        {
          path: 'kernels/:id',
          name: 'KernelDetail',
          component: () => import('@/views/kernel/Detail.vue'),
          meta: { pageTitle: 'Kernel Detail' },
        },
        {
          path: 'kernels/:id/versions',
          name: 'KernelVersions',
          component: () => import('@/views/kernel/Versions.vue'),
          meta: { pageTitle: 'Kernel Versions' },
        },
      ],
    },
    
    // 404
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/NotFound.vue'),
      meta: { pageTitle: '404 Not Found' },
    },

    // Admin routes
    {
      path: '/admin/login',
      name: 'AdminLogin',
      component: () => import('@/views/admin/Login.vue'),
      meta: { pageTitle: 'Admin Login' },
    },
    {
      path: '/admin',
      component: () => import('@/layouts/AdminLayout.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, pageTitle: 'Admin' },
      children: [
        {
          path: 'users',
          name: 'AdminUsers',
          component: () => import('@/views/admin/Users.vue'),
          meta: { pageTitle: '用户管理' },
        },
        {
          path: 'resources',
          name: 'AdminResources',
          component: () => import('@/views/admin/ResourceList.vue'),
          meta: { pageTitle: '资源上架申请' },
        },
        {
          path: 'resources/new',
          name: 'AdminResourceCreate',
          component: () => import('@/views/admin/ResourceForm.vue'),
          meta: { pageTitle: '新增资源申请' },
        },
        {
          path: 'resources/:id',
          name: 'AdminResourceDetail',
          component: () => import('@/views/admin/ResourceDetail.vue'),
          meta: { pageTitle: '资源申请详情' },
        },
        {
          path: 'resources/:id/edit',
          name: 'AdminResourceEdit',
          component: () => import('@/views/admin/ResourceForm.vue'),
          meta: { pageTitle: '编辑资源申请' },
        },
        {
          path: 'analytics',
          name: 'AdminAnalytics',
          component: () => import('@/views/admin/PageViews.vue'),
          meta: { pageTitle: '网站分析' },
        },
        {
          path: 'analytics/downloads',
          name: 'AdminDownloads',
          component: () => import('@/views/admin/Analytics.vue'),
          meta: { pageTitle: '下载分析' },
        },
        {
          path: 'news',
          name: 'AdminNews',
          component: () => import('@/views/admin/NewsManage.vue'),
          meta: { pageTitle: '资讯管理' },
        },
        {
          path: 'news/create',
          name: 'AdminNewsCreate',
          component: () => import('@/views/admin/NewsEdit.vue'),
          meta: { pageTitle: '发布资讯' },
        },
        {
          path: 'news/:id/edit',
          name: 'AdminNewsEdit',
          component: () => import('@/views/admin/NewsEdit.vue'),
          meta: { pageTitle: '编辑资讯' },
        },
        {
          path: 'api-keys',
          name: 'AdminApiKeys',
          component: () => import('@/views/admin/ApiKeys.vue'),
          meta: { pageTitle: 'API 密钥' },
        },
        {
          path: 'models',
          name: 'AdminModels',
          component: () => import('@/views/admin/ModelManage.vue'),
          meta: { pageTitle: '模型管理' },
        },
      ],
    },
  ],
})

// Navigation guard
router.beforeEach((to, _from, next) => {
  const lang = localStorage.getItem('flashhub_language') || localStorage.getItem('language') || 'en'
  const suffix = lang === 'zh' ? 'AI 模型推理加速引擎' : 'AI Model Inference Runtime'
  
  const pageTitle = to.meta.pageTitle as string
  const adminTitleMap: Record<string, { zh: string; en: string }> = {
    '用户管理': { zh: '用户管理', en: 'User Management' },
    '资源上架申请': { zh: '资源上架申请', en: 'Resource Listing' },
    '新增资源申请': { zh: '新增资源申请', en: 'New Resource Listing' },
    '资源申请详情': { zh: '资源申请详情', en: 'Resource Listing Detail' },
    '编辑资源申请': { zh: '编辑资源申请', en: 'Edit Resource Listing' },
    '网站分析': { zh: '网站分析', en: 'Site Analytics' },
    '下载分析': { zh: '下载分析', en: 'Download Analytics' },
    '资讯管理': { zh: '资讯管理', en: 'News Management' },
    '发布资讯': { zh: '发布资讯', en: 'New Article' },
    '编辑资讯': { zh: '编辑资讯', en: 'Edit Article' },
    'API 密钥': { zh: 'API 密钥', en: 'API Keys' },
    '模型管理': { zh: '模型管理', en: 'Model Management' },
  }
  const resolvedTitle = pageTitle ? (adminTitleMap[pageTitle]?.[lang as 'en' | 'zh'] || pageTitle) : ''
  if (resolvedTitle) {
    document.title = `${resolvedTitle} - ${suffix}`
  } else {
    document.title = `Flash Hub - ${suffix}`
  }
  
  // Check auth
  const isAdminRoute = to.path.startsWith('/admin')
  
  if (to.meta.requiresAuth) {
    if (isAdminRoute) {
      // Admin routes use adminStore
      const adminStore = useAdminStore()
      if (!adminStore.isLoggedIn) {
        next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
        return
      }
    } else {
      // User routes use userStore
      const userStore = useUserStore()
      if (!userStore.isLoggedIn) {
        if (userStore.token) {
          userStore.fetchProfile().then((success) => {
            if (success) {
              next()
            } else {
              next({ name: 'Login', query: { redirect: to.fullPath } })
            }
          })
          return
        } else {
          next({ name: 'Login', query: { redirect: to.fullPath } })
          return
        }
      }
    }
  }
  
  next()
})

// PV/UV tracking (all frontend pages)
router.afterEach((to) => {
  trackPageView(to.fullPath)
})

function getVisitorId(): string {
  const key = '_flashhub_vid'
  let vid = localStorage.getItem(key)
  if (!vid) {
    vid = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2)
    localStorage.setItem(key, vid)
  }
  return vid
}

let lastTracked = ''
function trackPageView(path: string) {
  if (path === lastTracked) return
  lastTracked = path
  const apiBase = (window as any).__APP_CONFIG__?.apiBaseUrl || '/api/v1'
  fetch(`${apiBase}/track/pageview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      path,
      visitor_id: getVisitorId(),
      referer: document.referrer || '',
      user_agent: navigator.userAgent || '',
    }),
  }).catch(() => {})
}

export default router